import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxIntuitiveToothEditorBridgeFacade } from '../../rx-intuitive-tooth-editor-bridge.facade';
import { RxIntuitiveBridgeDiagramFooterComponent } from '../../components/rx-intuitive-bridge-diagram-footer/rx-intuitive-bridge-diagram-footer.component';

@Component({
	selector: 'rx-intuitive-bridge-footer-container',
	templateUrl: './rx-intuitive-bridge-footer-container.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, RxIntuitiveBridgeDiagramFooterComponent]
})
export class RxIntuitiveBridgeFooterContainerComponent {
	readonly hasUnsavedChanges$ = this.bridgeFacade.hasUnsavedChanges$;
	readonly isReadOnly$ = this.bridgeFacade.toothEditorReadOnly$;

	constructor(private readonly bridgeFacade: RxIntuitiveToothEditorBridgeFacade) {}

	onSave(): void {
		this.bridgeFacade.saveBridge();
	}

	onRevert(): void {
		this.bridgeFacade.revertChanges();
	}

	onClose(): void {
		this.bridgeFacade.closeBridge();
	}
}
